import { httpInstancePaymentLink } from '@/services/httpInstance';
import { AxiosResponse } from 'axios';

const putMerchantService = async (dataParam: any): Promise<AxiosResponse | undefined> => {
  const endpoint = 'api/v1/merchants';

  try {
    const response = await httpInstancePaymentLink.put(endpoint, dataParam);
    return response;
  } catch (error: any) {
    return error.response;
  }
};

export default putMerchantService;
